import { Action } from 'redux';

import { SpaceType } from '~src/spacesPlatform/state/SpaceInfo';

import { SimulationCountsRequest } from '../../bootstrap/redux/actions/AppActionTypes';

export interface SimulationCountsRequestAction extends Action {
  spaceType: SpaceType;
}

export function simulationCountsRequest(
  spaceType: SpaceType
): SimulationCountsRequestAction {
  return {
    type: SimulationCountsRequest,
    spaceType
  };
}
